import PropTypes from 'prop-types';
import { useContext, useRef } from 'react';
import * as yup from 'yup';
import AuthContext from 'context/authContext';
import CrudCard from '../../common/CrudCard/CrudCard';
import {
  useCampaigns,
  useCreateCampaign,
  useUpdateCampaign,
  useDeleteCampaign
} from 'hooks/useDonationSettings';

/* -------------------------------------------------------------------------- */
function Campaigns({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();
  const { organization } = useContext(AuthContext);

  const { campaigns, isLoading: loading } = useCampaigns();
  const { createCampaign, isCreating: createLoading } = useCreateCampaign();
  const { updateCampaign, isUpdating: updateLoading } = useUpdateCampaign();
  const { deleteCampaign, isDeleting: deleteLoading } = useDeleteCampaign();

  const handleCreate = async (data) => {
    try {
      await createCampaign({
        name: data.name,
        organisation_id: organization.id
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (data) => {
    try {
      await updateCampaign({
        id: data.id,
        data: { name: data.data.name }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteCampaign(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const list = campaigns?.map(item => ({
    id: item.id,
    isOrgLevel: !item.branch_id,
    values: [
      {
        value: item.name,
        name: 'name'
      }
    ]
  }));
  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      loading={loading}
      editData={handleEdit}
      deleteData={handleDelete}
      createLoading={createLoading}
      updateLoading={updateLoading}
      deleteLoading={deleteLoading}
      formTitle={'Add Campaigns'}
      listTitle={'Current Campaigns'}
      title={'Campaigns'}
      inputs={[
        {
          name: 'name',
          placeholder: 'Add Campaign',
          type: 'text',
          required: true,
          value: '',
          validation: yup.string().required('Name is required')
        }
      ]}
      list={list}
      subject={subject}
    />
  );
}

Campaigns.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default Campaigns;
